export default "__VITE_ASSET__674e6d55__"